import { requestWithToken } from "../utils/apis";

export const deleteBlog = async (id) => {
    try {
      const response = await requestWithToken(
        "DELETE",
          `/api/blogs/${id}`,
      );
  
      return response.data;
    } catch (err) {
      return err.response.data;
    }
};


export const blogList = async (page, limit, locale= "en") => {
    try {
      const response = await requestWithToken(
        "GET",
        `/api/blogs?page=${page}&limit=${limit}&type=1&locale=${locale}&is_published=`,
      );
  
      return response.data;
    } catch (err) {
      return err.response.data;
    }
};
  
export const blogDetail = async (id) => {
  try {
    const response = await requestWithToken(
      "GET",
      `/api/blogs/${id}`,
    );

    return response.data;
  } catch (err) {
    return err.response.data;
  }
};